import { Component } from "@angular/core";

@Component({
    selector: "app-carrousel",
    templateUrl: "./carrousel.component.html",
    styleUrls: ["./carrousel.component.scss"]
})
export class CarrouselComponent {
}